<template>
<v-container fluid fill-height class="align-center">
  <v-row class="justify-center">
    <v-col cols=6>
      <v-card>
        <v-card-title>Welcome to ColourSpectrums</v-card-title>
        <v-card-text>
          Please send an email to Rob Chubb at rchubb@colourspectrums.com 
          with "Dashboard" in the subject line so we can activate your dashboard.
          We will confirm your request by return email. <br>
          Also, feel free to contact Rob directly anytime for activation and/or support at 780 907 5676.
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {};
</script>

<style>
</style>
